<template>
  <el-tooltip class="item" effect="dark" content="输入数字时按ID查询，否则按名称查询, 需指定站点查询" placement="top">

   <el-select
            v-if="type==2"
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="factorAutoComplete"
            placeholder="请输入楼盘名称/ID"
            :disabled="disabled"
    >
      <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.name">
      </el-option>
    </el-select>
     <el-select
            v-else
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="factorAutoComplete"
            placeholder="请输入楼盘名称/ID"
            :disabled="disabled"
    >
      <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
      </el-option>
    </el-select>    
  </el-tooltip>
</template>
<script>
    import { housesAutoComplete } from '@/service/housedict'
    // 目前不支持多选
    export default{
        props: {
            value: [Number, String],
            siteId: [Number, String],
            initChooseFirst: {
                type: Boolean,
                default: false
            },
            type:[Number, String]
        },
        data() {
            return {
                data: null,
                loading: false,
                options: [],
                searchTimeOutHandle: null,
                disabled: true
            }
        },
        created() {
            if (!!this.siteId === true) {
                this.disabled = false
                this.search(this.value, true)
            }
        },
        watch: {
            siteId(val) {
                this.onClean()
                this.search('')
            },
            value(val) {
                if (val !== this.data) {
                    this.search(val)
                }
            }
        },
        methods: {
            search(query, isInit = false) {
                this.loading = true
                clearTimeout(this.searchTimeOutHandle)
                if (!!this.siteId === false) {
                    this.onClean()
                    return
                }
                let conditions = {
                    site_id: this.siteId
                }
                if (!!query) {
                    if (/^\d+$/.test(query) === true) {
                        conditions.house_id = query
                    } else {
                        conditions.house_name = query
                    }
                }
                let that = this
                let timeout = isInit ? 0 : 300
                this.searchTimeOutHandle = setTimeout(() => {
                    housesAutoComplete(conditions).then(response => {
                        that.loading = false
                        that.options = response
                        that.data = null
                        if (response.length > 0) {
                            if (!!that.value) {
                                that.options.forEach(item => {
                                    if (item.id === that.value) {
                                        that.data = that.value
                                    }
                                })
                            } else if (that.initChooseFirst) {
                                that.data = response[0].id
                            }
                        }
                        that.onChange()
                        if (isInit) {
                            that.$emit('created', that.data)
                        }
                    }).catch(err => {
                        console.log(err)
                        that.loading = false
                    })
                }, timeout)
            },
            onChange(item) {
                this.$emit('input', this.data)
            },
            onClean() {
                if (!!this.siteId === false) {
                    this.disabled = true
                    this.options = []
                } else {
                    this.disabled = false
                }
                // this.options = []
                this.data = null
                this.$emit('input', '')
            }
        }
    }
</script>
